
import { useUserInfoStore } from "~/stores/userInfoStore"
export const getHotelName = () => {
    const userInfoStore = useUserInfoStore()

    if(!userInfoStore.info){
        console.log('userInfoStore.info is null')
        return ""
    }
    if(!userInfoStore.info.organization_id){
        console.log('userInfoStore.info.organization_id is null')
        return ""
    }
    
    if(!!userInfoStore.info.hotel) {
        return userInfoStore.info.hotel.name || ""
    }
    if(!!userInfoStore.info.organization) {
        return userInfoStore.info.organization.name || ""
    }
    
    return ""
}